import { useFormik } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import Footer from "../../components/footer/Footer";
import AuthConsumer from "../../utils/auth";
import api from "../../utils/axios";
import * as Yup from "yup";

import "./login.css";
import { message } from "antd";

export const formValidation = Yup.object().shape({
  username: Yup.string().required("common.required"),
  password: Yup.string().required("common.required"),
});

function Login() {
  const { t } = useTranslation();
  const [authed, dispatch] = AuthConsumer();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  // form
  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: formValidation,
    onSubmit: (values) => {
      setLoading(true);

      const requestBody = {
        username: values.username,
        password: values.password,
        // lastLoggedInTime: new Date.now(),
      };

      api
        .post("/auth/login", requestBody)
        .then(({ data }) => {
          message.info(t("common.welcome"));
          dispatch({ type: "login", token: data.token });
          setTimeout(() => {
            navigate("/", { replace: true });
          }, 500);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          if (error.response?.status === 401) {
            alert("Invalid username or password");
          } else {
            alert("Something went wrong. Check your internet connection.");
          }
        });
    },
  });
  return (
    <div className="login-page">
      <div className="login-card">
        {/* brand panel */}
        <aside className="login-brand">
          <div className="login-brand-top">
            <span className="login-mark" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="6" cy="6" r="3" />
                <circle cx="6" cy="18" r="3" />
                <path d="M20 4 8.12 15.88M14.47 14.48 20 20M8.12 8.12 12 12" />
              </svg>
            </span>
            <div className="login-wordmark gu">દરજી પોઇન્ટ</div>
            <div className="login-wordmark-en">Darji Point</div>
            <div className="login-brand-rule" aria-hidden="true"></div>
            <p className="login-brand-tag gu">
              પેન્ટ · શર્ટ · શૂટ · સફારી · શેરવાની ના સ્પેશ્યલીસ્ટ
            </p>
          </div>
          <p className="login-brand-foot">Bespoke Tailors · Surat</p>
        </aside>

        {/* form panel */}
        <div className="login-form-wrap">
          <form onSubmit={formik.handleSubmit} className="login-form">
            <div className="login-form-head">
              <h1>{t("common.login")}</h1>
              <p className="login-form-sub">Sign in to continue</p>
            </div>

            <div className="login-field">
              <label htmlFor="username">{t("common.username")}</label>
              <input
                type="text"
                id="username"
                name="username"
                value={formik.values.username}
                className="form-control"
                placeholder="Enter username"
                onChange={formik.handleChange}
              />
              {formik.errors.username && formik.touched.username ? (
                <p className="form-validation">{t(formik.errors.username)}</p>
              ) : null}
            </div>

            <div className="login-field">
              <label htmlFor="password">{t("common.password")}</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formik.values.password}
                className="form-control"
                onChange={formik.handleChange}
                placeholder="Enter password"
              />
              {formik.errors.password && formik.touched.password ? (
                <p className="form-validation">{t(formik.errors.password)}</p>
              ) : null}
            </div>

            <button type="submit" className="button-primary">
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span className="m-2">{t("common.loading")}</span>
                </>
              ) : (
                <span className="m-2">{t("common.clickMe")}</span>
              )}
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Login;
